import React from "react";

import styles from "./SidePanel.module.scss";

import { observer } from "mobx-react";
import { Previewer as FileViewer } from "modules/common/components/files/Previewer";
import { FileMetadataSnapshotType } from "modules/common/models/file-metadata";
import { RenderCacheType } from "modules/orders-manage/models/orders-store";
import { Documents } from "./Documents";

import { LocalLoader } from "modules/common/components/loader/Loader";
import { texts } from "modules/common/texts";

import { PlanrButton } from "modules/common/components/planr/button/Button";
import { OrderConfirmSnapshotType } from "modules/orders-manage/models/order-confirm";
import { OrderConfirmFileSnapshotType } from "modules/orders-manage/models/order-file";

interface SidePanelProps {
  selection: OrderConfirmSnapshotType | null;
  renderer: RenderCacheType;
  onPreview: (document: FileMetadataSnapshotType | null) => void;
  goBack: (from: OrderConfirmSnapshotType) => void;
  goForward: (from: OrderConfirmSnapshotType) => void;
  onPrint: (fileId: string) => void;
  onDownload: (fileId: string) => void;
  loading: boolean;
  canClientEdit?: boolean;
}

class Panel extends React.Component<SidePanelProps> {
  render() {
    const { selection, renderer, onPreview, loading, canClientEdit } = this.props;

    let docs: OrderConfirmFileSnapshotType[] = [];
    if (canClientEdit) {
      docs = selection ? selection.resultFiles.map((file) => ({ ...file, name: `Результат: ${file.name}` })) : [];
    } else {
      docs = selection
        ? selection.requestFiles
            .map((file) => ({ ...file, name: `Запрос: ${file.name}` }))
            .concat(selection.sourceFiles.map((file) => ({ ...file, name: `Исходник: ${file.name}` })))
            .concat(selection.resultFiles.map((file) => ({ ...file, name: `Результат: ${file.name}` })))
        : [];
    }

    return (
      <div className={`side-panel ${styles.details}`}>
        <LocalLoader active={loading} />

        {selection && (
          <>
            <div className={styles.detailsTools}>
              <div className={styles.detailsBtns}>
                <PlanrButton
                  type="graybtn"
                  icon="general-big-arrow-left"
                  onClick={this.goBack}
                  title="Предыдущее письмо"
                  round={true}
                  size="small"
                />
                <PlanrButton
                  type="graybtn"
                  icon="general-big-arrow-right"
                  onClick={this.goForward}
                  title="Следующее письмо"
                  round={true}
                  size="small"
                />
              </div>
              <div className={styles.detailsBtns}>
                <PlanrButton
                  type="graybtn"
                  icon="general-download"
                  onClick={this.download}
                  title={`${texts.download} файл`}
                  round={true}
                  size="small"
                />
                <PlanrButton
                  type="graybtn"
                  icon="general-print"
                  onClick={this.print}
                  title={`${texts.print} файл`}
                  round={true}
                  size="small"
                />
              </div>
            </div>
            <div className={styles.viewer}>
              <div className={styles.detailsFiles}>
                {docs && docs.length > 0 && <Documents columns={4} documents={docs} onSelect={onPreview} />}
              </div>

              <FileViewer document={renderer.viewer} />
            </div>
          </>
        )}
      </div>
    );
  }

  goBack = () => this.props.selection && this.props.goBack(this.props.selection);

  goForward = () => this.props.selection && this.props.goForward(this.props.selection);

  print = () => {
    if (this.props.renderer.id) {
      this.props.onPrint(this.props.renderer.id);
    }
  };

  download = () => {
    if (this.props.renderer.id) {
      this.props.onDownload(this.props.renderer.id);
    }
  };
}

export const SidePanel = observer(Panel);
